var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.html",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true,"html":true}}],staticClass:"dashboard-express-quotation-form-goods-dropdown-help tw-flex",class:{
    'has-error': _vm.hasError
  },on:{"click":_vm.click}},[_c('ui-material-icon',{staticClass:"tw-m-auto tw-text-base",attrs:{"name":"info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }